// extracted by mini-css-extract-plugin
module.exports = {"card":"CardArticle_card__roZpF","image":"CardArticle_image__TcSr1","body":"CardArticle_body__5y9yT","info":"CardArticle_info__odIwq"};